<div class="psmt-prestador-container">
    <app-card-content [border]="false" [headerColor]="true" icon="pi pi-bookmark" title="PSMT" subtitle="Locais de Prestação de Serviço Médico Terceirizados">
        <div class="psmt-toolbar">
            <div>
                <span class="toolbar-title">Prestadores Clientes</span>
                <span class="toolbar-subtitle">Prestadores vinculados ao PSMT do cadastro atual.</span>
            </div>

            <p-select appendTo="body" [(ngModel)]="filtroPsmt" [options]="filtrosPsmt" optionLabel="label" optionValue="value" styleClass="w-48" (onChange)="onFiltroAlterado()" />
        </div>

        <app-card-content [headerColor]="false" icon="pi pi-building" title="Prestadores Clientes">
            <app-custom-table
                [metadata]="prestadoresClientesMetadata"
                [data]="prestadoresClientesTabela()"
                [columnOrder]="prestadoresClientesColumnOrder"
                [loading]="carregando()"
                [first]="first()"
                [rows]="rows()"
                [totalRecords]="totalRecords()"
                [rowsPerPageOptions]="[10, 15, 20]"
                [showActions]="true"
                [showExpandButton]="true"
                [initialViewMode]="'table'"
                [cardColumns]="2"
                (onPageChange)="onPaginaAlterada($event)"
            />

            <div class="table-footer">
                <div class="legend">
                    <span class="legend-color"></span>
                    <span>Não possui PSMT ativo em corpo clínico</span>
                </div>

                <span>Total: {{ totalRecords() }}</span>
            </div>
        </app-card-content>
    </app-card-content>

    <p-dialog
        appDialogoPadrao="pi pi-info-circle"
        descricao="Programa de Saúde e Medicina do Trabalho."
        [visible]="detalhesDialogVisivel()"
        (visibleChange)="detalhesDialogVisivel.set($event)"
        (onHide)="fecharDetalhes()"
        [style]="{ width: 'min(94vw, 760px)' }"
        [breakpoints]="{ '960px': '92vw', '640px': '96vw' }"
        [appendTo]="'body'"
        header="Detalhes PSMT"
        styleClass="psmt-detalhes-dialog"
    >
        @if (prestadorClienteDetalhe(); as prestador) {
            <div class="dialog-header-info">
                <div>
                    <span class="toolbar-title">{{ prestador.razaoSocial || 'Prestador cliente' }}</span>
                    <span class="toolbar-subtitle">{{ prestador.uf }} {{ prestador.crm }}</span>
                </div>
            </div>

            <div class="psmt-details-grid">
                <app-card-content [headerColor]="true" icon="pi pi-info-circle" title="Informações Gerais de Classificação">
                    <div class="readonly-grid">
                        <div class="readonly-field wide">
                            <span class="readonly-label">Classificação</span>
                            <span class="readonly-value">{{ prestador.classificacao || '-' }}</span>
                        </div>

                        <div class="readonly-field">
                            <span class="readonly-label">Porte</span>
                            <span class="readonly-value">{{ prestador.porte || '-' }}</span>
                        </div>
                    </div>
                </app-card-content>

                <app-card-content [headerColor]="true" icon="pi pi-verified" title="Certificado de Regularidade">
                    <div class="readonly-grid certificate-grid">
                        <div class="readonly-field">
                            <span class="readonly-label">Val. Certificado</span>
                            <span class="readonly-value">{{ formatarData(prestador.validadeCertificado) }}</span>
                        </div>

                        <div class="readonly-field">
                            <span class="readonly-label">Status</span>
                            <span class="certificate-tag" [style.background]="certificadoDetalhe().color" [style.color]="certificadoDetalhe().textColor">
                                {{ certificadoDetalhe().value }}
                            </span>
                        </div>
                    </div>
                </app-card-content>
            </div>
        }
    </p-dialog>

    <p-dialog
        appDialogoPadrao="pi pi-users"
        descricao="Médicos vinculados ao programa."
        [visible]="medicosDialogVisivel()"
        (visibleChange)="medicosDialogVisivel.set($event)"
        (onHide)="fecharMedicos()"
        [style]="{ width: 'min(94vw, 1024px)' }"
        [breakpoints]="{ '960px': '92vw', '640px': '96vw' }"
        [appendTo]="'body'"
        header="Médicos PSMT"
        styleClass="psmt-medicos-dialog"
    >
        <div class="dialog-header-info">
            <div>
                <span class="toolbar-title">{{ prestadorClienteSelecionado()?.razaoSocial || 'Prestador cliente' }}</span>
                <span class="toolbar-subtitle">{{ prestadorClienteSelecionado()?.uf }} {{ prestadorClienteSelecionado()?.crm }}</span>
            </div>

            <p-select [(ngModel)]="composicaoPsmt" [options]="composicoesPsmt" optionLabel="label" optionValue="value" styleClass="w-56" appendTo="body" (onChange)="onComposicaoAlterada()" />
        </div>

        <app-custom-table
            [metadata]="medicosMetadata"
            [data]="medicosTabela()"
            [columnOrder]="medicosColumnOrder"
            [loading]="medicosCarregando()"
            [first]="medicosFirst()"
            [rows]="medicosRows()"
            [totalRecords]="medicosTotalRecords()"
            [rowsPerPageOptions]="[10, 15, 20]"
            [showActions]="true"
            [showExpandButton]="true"
            [initialViewMode]="'table'"
            [cardColumns]="2"
            (onPageChange)="onPaginaMedicosAlterada($event)"
        />

        <div class="table-footer">
            <div class="legend-group">
                <div class="legend">
                    <span class="legend-color debt"></span>
                    <span>Médicos Devedores</span>
                </div>
                <div class="legend">
                    <span class="legend-color deceased"></span>
                    <span>Médicos Falecidos</span>
                </div>
            </div>

            <span>Total: {{ medicosTotalRecords() }}</span>
        </div>
    </p-dialog>
</div>
